var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "66px",
    viewBox: "0 0 88 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_volver copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav",
    transform: "translate(-676, -1183)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_volver-copy-3",
    transform: "translate(676, 1183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3698521,16.9644185 L6.08716513,16.9644185 L20.6189524,2.48858205 L18.1207517,0 L0.527788884,17.5252257 C-0.175929628,18.2262347 -0.175929628,19.3127987 0.527788884,20.0138078 L18.1207517,37.5390335 L20.6189524,35.0504514 L5.94642143,20.4344132 L63.3698521,20.4344132 C74.9812075,20.4344132 84.4462215,29.8629846 84.4814074,41.4296336 C84.4814074,53.031333 75.0163934,62.4949549 63.3698521,62.4949549 L35.2211116,62.4949549 L35.2211116,66 L63.3698521,66 C76.9164334,66 87.9648141,54.9941583 88,41.464684 C88,27.9352098 76.9516194,16.9644185 63.3698521,16.9644185 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGray);
export default __webpack_public_path__ + "static/media/back-gray.346da5375e3af51c6871bc2f5b8b1efd.svg";
export { ForwardRef as ReactComponent };